module.exports = __webpack_public_path__ + "img/404_2.8a7c7ea7.png";